module.exports = __webpack_public_path__ + "img/recycle_selector.f12653e7.png";